import { RemoteGetAppRegisteredStudentsPerGroup } from 'data/usecases';
import { GetAppRegisteredStudentsPerGroupUseCaseInterface } from 'domain/usecases';
import { makeApiUrlAppRegisteredStudentsPerGroup } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeGetAppRegisteredStudentsPerGroup =
  (): GetAppRegisteredStudentsPerGroupUseCaseInterface =>
    new RemoteGetAppRegisteredStudentsPerGroup(
      makeApiUrlAppRegisteredStudentsPerGroup(),
      makeAxiosHttpClient(),
    );
